<template>
  <div class="title-header">
    <router-link v-if="prev !== undefined" class="title-header__prev" :to="prevLink">
      <img src="/img/prev.svg" alt="">
    </router-link>
    <h2 class="h2" :class="titleClass">
      <template v-if="title !== undefined && title !== ''">
        {{title}}
      </template>
      <template v-else>
        {{$route.meta.title}}
      </template>
    </h2>
    <h3 v-if="secondTitle !== undefined && secondTitle !== '' && secondTitle !== 'undefined'"
        class="h3 mb0 mt5"
    >
      {{secondTitle}}
    </h3>
    <p v-if="desc !== undefined"
       class="title-header__desc"
       :class="{'mt20': secondTitle === undefined || secondTitle === '' || secondTitle === 'undefined'}"
    >
      {{desc}}
    </p>
  </div>
</template>

<script>
  export default {
    name: "Title",
    props: {
      prev: {},
      secondTitle: {
        type: String
      },
      desc: {
        type: String
      },
      title: {
        type: String
      },
      titleClass: {
        type: String,
        default: ''
      }
    },
    computed: {
      prevLink() {
        if (this.$route.name !== 'check-answers') {
          return {name: this.prev};
        }
        else {
          for (let i = 0; i < this.$store.state.answers.answersData.length; i++) {
            if (this.$store.state.answers.answersData[i] === this.$route.params.q_id) {
              if (i === 0) {
                return {name: 'check-generations'};
              }
              else {
                let to = {};
                to.params = {};
                Object.assign(to.params, this.$route.params);
                to.params.q_id = this.$store.state.answers.answersData[i - 1];
                to.name = 'check-answers';
                return to;
              }
            }
          }
        }
      }
    },
  }
</script>

<style lang="scss">
  .title-header {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 39px 20px;
    min-height: 121px;
    width: 100%;
    @media (max-width: 575px) {
      min-height: 90px;
    }
    &__prev {
      position: absolute;
      left: -20px;
      @media (max-width: 575px) {
        left: 0;
      }
    }
    &__desc {
      margin-top: 28px;
      font-size: 14px;
      color: #8E8E8E;
    }
  }
</style>